enum FileStatus {
  DONE = 'done',
  UPLOADING = 'uploading',
  REMOVED = 'removed',
}

export default FileStatus
